import type {
    AssistedResultItem,
    PrimaryResultItem,
    SearchResultRow,
    SearchResultSource,
    SearchSource,
} from '../search.types';

function mapSearchResult(item: SearchSource['items'][number]): SearchResultRow {
    const resultId = `${item.kind}:${item.id}`;
    const primary: PrimaryResultItem = {
        action: 'primary',
        id: `${resultId}:primary`,
        item,
    };

    if (item.kind === 'product') return { primary };

    const assisted: AssistedResultItem = {
        action: 'assisted',
        id: `${resultId}:assisted`,
        item,
    };

    return { assisted, primary };
}

export function mapSearchResults(sources: readonly SearchSource[]): SearchResultSource[] {
    return sources.map(source => {
        const rows = source.items.map(mapSearchResult);

        return {
            kind: source.kind,
            items: rows.flatMap(row => (row.assisted ? [row.primary, row.assisted] : [row.primary])),
            rows,
        };
    });
}
